{
  "timeline": {
    "title": "Seu período de teste gratuito",
    "day0Label": "Hoje",
    "day0Description": "Início do teste",
    "reminderLabel": "Dia {{day}}",
    "reminderDescription": "E-mail de lembrete enviado",
    "trialEndLabel": "Dia {{days}}",
    "trialEndDescription": "Fim do teste — adicione um cartão para continuar usando o AllDrivers"
  },
  "banner": {
    "honestReminder": "Período de teste: faltam {{daysRemaining}} de {{trialDays}} dias",
    "trialEndingSoon": "Seu período de teste termina em {{daysRemaining}} dias",
    "trialEndedOwner": "Seu período de teste terminou — adicione um método de pagamento para continuar",
    "trialEndedDriverGrace": "O período de teste da sua empresa terminou. Faltam {{graceDaysRemaining}} dias — pague sua própria licença para continuar dirigindo"
  },
  "expired": {
    "titleOwner": "O período de teste terminou",
    "titleDriver": "O acesso da sua empresa terminou",
    "bodyOwner": "Como avisamos na linha do tempo do teste, para continuar usando o AllDrivers é preciso ativar a assinatura. Os seus dados estão guardados.",
    "bodyDriver": "O período de tolerância da sua empresa terminou. Pague a sua própria licença para continuar dirigindo — ou fale com o seu gestor.",
    "ctaOwner": "Ativar assinatura",
    "subscriptionError": "Não foi possível criar a assinatura.",
    "ctaDriver": "Pagar a minha licença"
  },
  "selfPay": {
    "title": "Pague a sua própria licença",
    "body": "Continue dirigindo com o AllDrivers mesmo que a sua empresa deixe de pagar — a licença fica sua, associada à sua conta.",
    "cardUpfront": "Teste grátis de {{days}} dias — o cartão é pedido já, mas só é cobrado no fim do teste.",
    "cta": "Ativar a minha licença",
    "checkoutError": "Não foi possível iniciar o pagamento. Tente novamente.",
    "exitDashboard": "Voltar ao início",
    "exitLogout": "Sair",
    "unknownBody": "Não foi possível confirmar a sua licença. Verifique a conexão e tente novamente.",
    "retry": "Tentar novamente"
  }
}
